export const percentToRatio = percent => {
  const [integerPart, fractionalPart = ''] = String(percent).split('.');
  const paddedIntegerPart = integerPart.padStart(3, '0');
  const digits = `${paddedIntegerPart}${fractionalPart}`;
  const decimalPosition = paddedIntegerPart.length - 2;

  return `${digits.slice(0, decimalPosition)}.${digits.slice(decimalPosition)}`
    .replace(/^0+(?=\d)/, '')
    .replace(/\.?0+$/, '');
};

export const ratioToPercent = ratio => {
  const [integerPart, fractionalPart = ''] = String(ratio).split('.');
  const paddedFractionalPart = fractionalPart.padEnd(2, '0');
  const percentIntegerPart = `${integerPart}${paddedFractionalPart.slice(0, 2)}`.replace(/^0+(?=\d)/, '');
  const percentFractionalPart = paddedFractionalPart.slice(2).replace(/0+$/, '');

  return percentFractionalPart ? `${percentIntegerPart}.${percentFractionalPart}` : percentIntegerPart;
};
